<div class="selection-container">
  <div class="selection-primary">
    <button mat-raised-button class="create-config-btn" data-testid="ad-savannaconfig-create-button" (click)="onCreateConfiguration()" [disabled]="isLoading || pendingChanges">
      <mat-icon>add</mat-icon>
      Create
    </button>
    <mat-form-field class="assay-form-field" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Assay</mat-label>
      <mat-select [(value)]="selectedAssayId" data-testid="ad-savannaconfig-assay-select" (selectionChange)="onAssayIdChange()" [disabled]="isLoading">
        <mat-option *ngFor="let assayId of currentAssayIds" [value]="assayId">
          {{ assayId }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="revision-form-field" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Revision</mat-label>
      <mat-select [(value)]="selectedRevisionId" data-testid="ad-savannaconfig-revision-select" (selectionChange)="onRevisionChange()" [disabled]="isLoading">
        <mat-option *ngFor="let revisionId of currentAssayRevisions" [value]="revisionId">
          {{ revisionId == -1 ? '(none)' : revisionId }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <button
      mat-icon-button
      matTooltip="Delete Configuration {{ selectedAssayId }}.{{ selectedRevisionId }}"
      class="delete-btn"
      color="warn"
      data-testid="ad-savannaconfig-delete-button"
      (click)="onDeleteConfiguration()"
      *ngIf="selectedAssayId && selectedRevisionId"
      [disabled]="isLoading">
      <mat-icon>delete</mat-icon>
    </button>
    <span class="notification-msg-box" *ngIf="pendingChanges">
      ** Changes currently pending, don't forget to save! **
    </span>
    <div class="edit-actions">
      <button
        mat-raised-button
        class="reset-btn"
        data-testid="ad-savannaconfig-reset-button"
        (click)="onRevisionChange()"
        *ngIf="pendingChanges"
        [disabled]="isLoading">
        Reset
      </button>
      <button
        mat-raised-button
        class="save-btn"
        color="primary"
        data-testid="ad-savannaconfig-save-button"
        (click)="saveChanges()"
        *ngIf="pendingChanges"
        [disabled]="isLoading">
        Save
      </button>
    </div>
  </div>
</div>
<div class="configuration-container" data-testid="ad-savannaconfig-container">
  <div class="chamber-channel-container" *ngIf="selectedAssayId && selectedRevisionId">
    <p-table
      [value]="tableData"
      dataKey="id"
      responsiveLayout="scroll"
      class="config-table"
      (onEditComplete)="onEditComplete($event)"
      data-testid="ad-savannaconfig-table">
      <ng-template pTemplate="caption">
        <div class="table-header" data-testid="ad-savannaconfig-table-header">
          {{ tableData[0][0].assayName }}
          <mat-icon data-testid="ad-savannaconfig-editname-icon" (click)="onEditName()" matTooltip="Edit the configuration name">edit</mat-icon>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th class="chamber-column">Chamber</th>
          <th class="channel-{{ idx + 1 }}" *ngFor="let chamberName of chamberNames; let idx = index">
            {{ chamberName }}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-config let-rowData let-rowIndex="rowIndex">
        <tr *ngIf="rowIndex != 0">
          <td class="chamber-column">{{ config[0]?.shortName ?? '' }}</td>
          <td
            [pEditableColumn]="rowData[colIdx]"
            [pEditableColumnRowIndex]="colIdx"
            class="channel-{{ colIdx }}"
            *ngFor="let colIdx of editableColumnIndices"
            [pEditableColumnDisabled]="isLoading">
            <p-cellEditor class="editable-cell">
              <ng-template pTemplate="input">
                <mat-form-field appearance="outline" class="cell-input-field" subscriptSizing="dynamic">
                  <input matInput type="text" [(ngModel)]="config[colIdx].shortName" [attr.data-testid]="'ad-savannaconfig-shortname-input-' + rowIndex + '-' + colIdx" />
                </mat-form-field>
              </ng-template>
              <ng-template pTemplate="output">
                {{ config[colIdx]?.shortName ?? '' }}
              </ng-template>
            </p-cellEditor>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="position-container" *ngIf="selectedAssayId && selectedRevisionId">
    <h2>Column Display Position</h2>
    <div cdkDropList class="config-list" (cdkDropListDropped)="onDropConfig($event)" data-testid="ad-savannaconfig-positions-list">
      <div class="config-box" *ngFor="let config of positionalConfigurations; let idx = index" cdkDrag [attr.data-testid]="'ad-savannaconfig-position-' + config.position">
        Position {{ config.position + 1 }}: {{ config.shortName }} (Chamber {{ config.chamber }}, Channel
        {{ config.channel }})
        <button matSuffix mat-icon-button class="delete-assay-btn" [attr.data-testid]="'ad-savannaconfig-deleteassay-button-' + config.position" (click)="onClickDeleteAssay(config)">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
